export default "__VITE_ASSET__TRcnSf$a__"